import React from 'react'

const useKeyPress = (targetKey: string | null, callback: () => void) => {
    React.useEffect(() => {
        const handler = ({key}: KeyboardEventInit) => {
            if (targetKey === null || key === targetKey) {
                callback()
            }
        }

        window.addEventListener('keydown', handler)

        return () => {
            window.removeEventListener('keydown', handler)
        }
    }, [targetKey, callback])
}

export default useKeyPress
